module.exports = __webpack_public_path__ + "static/media/camera_yellow.de341247.svg";